<template>
  <div class="header">
    <div class="reload">
      <i class="fa fa-refresh" aria-hidden="true" v-on:click="reloadCallback"></i>
    </div>
    <select-date :set-date-callback="setDateCallback" :value="dataSelecionada"></select-date>
    <div class="total-hours">
      <h5>Total de horas apontadas:</h5>
      <h1>
        {{ totalHoras }}
        <i class="fa fa-clock-o" aria-hidden="true"></i>
      </h1>
    </div>
  </div>
</template>

<style lang="scss">
.header {
  background-color: white;
  border-radius: 15px 15px 0 0;
  margin-bottom: 15px;
  border: 1px solid #ccc;
  display: flex;
  align-items: center;

  .reload>i {
    font-size: 34px;
    color: #5b6772;
    margin-left: 30px;
    cursor: pointer;
  }

  .total-hours {
    width: 100%;
    margin-right: 30px;
    text-align: end;

    h1 {
      color: #4f5963;
    }

    h5,
    i {
      color: #5b6772;
    }
  }
}
</style>

<script>
import SelectDate from './SelectDate'
export default {
  name: 'HeaderLancamento',
  components: {
    SelectDate,
  },
  props: {
    setDateCallback: {
      type: Function,
      default: () => { }
    },
    reloadCallback: {
      type: Function,
      default: () => { }
    },
    totalHoras: {
      type: String,
      default: '00:00'
    },
    dataSelecionada: {
      type: String,
      default: null
    }
  },
}
</script>